import React, { useState } from "react";
import "./Auth.css";
import logo from "../../img/logo.png"; // Your app's logo
import googleIcon from "../../img/google-icon.svg"; // Google icon
import api from "../../api"; // Adjust the path to your API file

const Login = () => {
  const [showPartnerForm, setShowPartnerForm] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGoogleLogin = () => {
    // Build the URL based on the API base URL from your API file
    window.location.href = `${api.defaults.baseURL}/auth/google`;
  };

  const handlePartnerButtonClick = () => {
    setShowPartnerForm(true);
    setError("");
  };

  const handlePartnerLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      console.log("[LOGIN] Starting partner login...");
      const response = await api.post("/partner/login", {
        username,
        password
      });

      const { token, user } = response.data;
      console.log("[LOGIN] Login successful, received user:", user);

      // Store token and user info
      localStorage.setItem("partnerToken", token);
      localStorage.setItem("partnerUser", JSON.stringify(user));
      console.log("[LOGIN] Stored to localStorage - token length:", token?.length, "user:", user);

      // Set token in API headers
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      console.log("[LOGIN] Set Authorization header");

      // Check for post-login redirect
      const redirectTo = localStorage.getItem("postLoginRedirect");
      console.log("[LOGIN] Post-login redirect:", redirectTo);
      
      if (redirectTo) {
        localStorage.removeItem("postLoginRedirect");
        console.log("[LOGIN] Redirecting to:", redirectTo);
        window.location.href = redirectTo;
      } else {
        // Force a full page reload to ensure AuthContext picks up the stored user
        console.log("[LOGIN] Redirecting to /dashboard");
        window.location.href = "/dashboard";
      }
    } catch (err) {
      console.error("[LOGIN] Partner login error:", err);
      setError(err.response?.data?.error || "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <img src={logo} alt="Logo" className="responsive-logo" />
      
      {!showPartnerForm ? (
        <>
          {/* Employee Login Section */}
          <div className="login-section">
            <h3>Employee Login</h3>
            <button className="google-button" onClick={handleGoogleLogin}>
              <img src={googleIcon} alt="Google icon" className="google-icon" />
              Sign in with Google
            </button>
          </div>

          {/* Partner Login Section - HIDDEN */}
          {/* <hr className="login-separator" />
          <div className="login-section">
            <h3>Partner Login</h3>
            <button className="partner-button" onClick={handlePartnerButtonClick}>
              Login
            </button>
          </div> */}
        </>
      ) : (
        <>
          <form onSubmit={handlePartnerLogin} className="auth-form">
            <h3>Partner Login</h3>
            
            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Enter username"
              />
            </div>
            
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter password"
              />
            </div>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            <button 
              type="submit" 
              className="btn-primary"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>

            <button 
              type="button"
              className="link-button"
              onClick={() => {
                setShowPartnerForm(false);
                setError("");
                setUsername("");
                setPassword("");
              }}
            >
              ← Back
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default Login;
